import OutrosRealizado from "./OutrosRealizado";
import OutrosMeta from './OutrosMeta';
import Refrigerante from "./Refrigerante";

const Metas = () => {

    return (
        <>
            
            
                <div className="card">
                    <div className="card-header bg-light" id="headingOne">
                        <h5 className="">
                            <a className="collapsed btn text-primary text-uppercase" data-bs-toggle="collapse" href="#collapseOne">
                                <h5>
                                    Metas por familia
                                </h5>
                            </a>
                        </h5>
                    </div>
                    <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                        <OutrosMeta />
                    </div>
                </div>

                <div className="card mt-3">
                    <div className="card-header" id="headingTwo">
                        <h5 className="mb-0">
                            <a className="collapsed btn text-primary" data-bs-toggle="collapse" href="#collapseTwo">
                                <h5>
                                    REALIZADO POR FAMILIA
                                </h5>
                            </a>
                        </h5>
                    </div>
                    <div id="collapseTwo" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordion">
                        <OutrosRealizado />
                    </div>
                </div>

                <div className="card mt-3 mb-3">
                    <div className="card-header" id="headingThree">
                        <h5 className="mb-0">
                            <a className="collapsed btn text-primary" data-bs-toggle="collapse" href="#collapseThree">
                                <h5>
                                    REFRIGERANTES POR EMBALAGEM
                                </h5>
                            </a>
                        </h5>
                    </div>
                    <div id="collapseThree" className="collapse show" aria-labelledby="headingThree" data-parent="#accordion">
                        <Refrigerante />
                    </div>
                </div>

        </>
    )
}

export default Metas;